import React from 'react';
import PropTypes from 'prop-types';

const FacebookFilled = props => {
  const { id, ...rest } = props;

  return (
    <svg
      id={id}
      width={18}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M11.964 4.03c.598 0 .997-.4.997-1V1c0-.6-.399-1-.997-1H8.973c-3.29 0-4.985 1.7-4.985 5v3H.997C.399 8 0 8.4 0 9v1.999c0 .6.399 1 .997 1h3.002V20c0 .6.399 1 .997 1h2.061c.598 0 .997-.4.997-1v-8.015h2.913c.498 0 .897-.3.997-.8l.997-1.929c.1-.3 0-.6-.2-.9-.199-.3-.498-.3-.797-.3h-3.91V4.03h3.91z"
        id={`${id}-path`}
      />
    </svg>
  );
};

FacebookFilled.propTypes = {
  id: PropTypes.string,
};

FacebookFilled.defaultProps = {
  id: 'facebook-filled',
};

export default FacebookFilled;
